/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import { utils, WidgetProps } from '@rjsf/core';
import { useTranslation } from 'react-i18next';
import { Theme, useMediaQuery } from '@material-ui/core';
import DateAndTimePicker from '../../DatePicker/DateAndTimePicker';

const { localToUTC, utcToLocal, getDisplayLabel } = utils;

const DateTimeWidget: React.FC<WidgetProps> = ({
  id,
  placeholder,
  readonly,
  disabled,
  label,
  value,
  onChange,
  autofocus,
  schema,
  uiSchema,
  rawErrors = [],
}: WidgetProps) => {
  const { t } = useTranslation();
  const isSmallDevice = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const _value = utcToLocal(value);
  const _onChange = (v: string) => {
    onChange(localToUTC(v));
  };

  const displayLabel = getDisplayLabel(schema, uiSchema);

  return (
    <DateAndTimePicker
      value={_value}
      onChange={_onChange}
      isSmallDevice={isSmallDevice}
      t={t}
      disabled={disabled}
      controls={['calendar', 'time']}
      inputProps={{
        variant: 'filled',
        label: displayLabel ? label || schema.title : '',
        disabled,
        autoFocus: autofocus,
        placeholder,
        id,
        inputProps: {
          'data-testid': 'datetime-widget',
          // trigger rerender when _value changes
          key: new Date(_value).getTime(),
        },
        InputProps: {
          readOnly: readonly,
        },
      }}
    />
  );
};

export default DateTimeWidget;
